import smallLogo from '../assets/images/brands/default/logo-small.svg'
import largeLogo from '../assets/images/brands/default/logo-large.svg'

export interface BrandingConfig {
  company: {
    name: string
    website: string
    supportEmail: string
  }
  assets: {
    logoSmall: string
    logoLarge?: string
  }
  theme: {
    colors: {
      primary: string
      primaryLight: string
      secondary: string
      background: string
      cardBackground: string
      text: string
      textLight: string
    }
  }
}

const branding: BrandingConfig = {
  company: {
    name: 'AgileView',
    website: 'https://agileview.ai',
    supportEmail: 'info@agileview.ai',
  },
  assets: {
    logoSmall: smallLogo,
    logoLarge: largeLogo,
  },
  theme: {
    colors: {
      primary: '#0d6efd',
      primaryLight: 'rgba(13, 110, 253, 0.5)',
      secondary: '#6c757d',
      background: '#000000',
      cardBackground: '#1a1a1a',
      text: '#ffffff',
      textLight: 'rgba(255, 255, 255, 0.8)',
    },
  },
}

export default branding
